import type { GateSrs } from "./types";

const DAY = 86_400_000;
const LAPSE_DELAY = 10 * 60 * 1000; // 10 minutes — a lapsed gate returns this run

export function emptySrs(): GateSrs {
  return { reps: 0, ease: 2.3, interval: 0, dueAt: 0, attempts: 0, correct: 0 };
}

/** SM-2-lite. A passed gate gets a growing interval; a lapse drops it back. */
export function reviewGate(srs: GateSrs, correct: boolean, now: number = Date.now()): GateSrs {
  const attempts = srs.attempts + 1;
  const correct_ = srs.correct + (correct ? 1 : 0);

  if (!correct) {
    return {
      reps: 0,
      ease: Math.max(1.3, srs.ease - 0.2),
      interval: 0,
      dueAt: now + LAPSE_DELAY,
      attempts,
      correct: correct_,
    };
  }

  const reps = srs.reps + 1;
  let interval: number;
  if (reps === 1) interval = 1;
  else if (reps === 2) interval = 3;
  else interval = Math.max(1, Math.round(srs.interval * srs.ease));
  const ease = Math.min(2.8, srs.ease + 0.05);

  return { reps, ease, interval, dueAt: now + interval * DAY, attempts, correct: correct_ };
}

/** Ever successfully answered (drives the headline mastery count, which never regresses). */
export function gatePassed(srs: GateSrs): boolean {
  return srs.reps >= 1;
}

/** Passed before but now overdue — eligible for a review duel. */
export function gateDue(srs: GateSrs, now: number = Date.now()): boolean {
  return srs.reps >= 1 && srs.dueAt > 0 && srs.dueAt <= now;
}

/** How overdue a gate is, in days (negative = not yet due). Used for review ordering. */
export function overdueDays(srs: GateSrs, now: number = Date.now()): number {
  if (srs.dueAt <= 0) return -Infinity;
  return (now - srs.dueAt) / DAY;
}
